import { SourceLinks } from '@/components/ui/source-links';
import { Users } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';
import { useState } from 'react';

interface SpecificAudienceCardProps {
    audience: {
        specificAudience: string;
        situation: string;
        differencesFromBook: string;
        sources?: Source[];
    };
    isExpanded?: boolean;
    onToggleExpansion?: () => void;
    defaultExpanded?: boolean;
    title?: string;
}

export function SpecificAudienceCard({
    audience,
    isExpanded: controlledIsExpanded,
    onToggleExpansion: controlledOnToggleExpansion,
    defaultExpanded = false,
    title = "The Specific Audience"
}: SpecificAudienceCardProps) {
    const [internalIsExpanded, setInternalIsExpanded] = useState(defaultExpanded);

    const isExpanded = controlledIsExpanded !== undefined ? controlledIsExpanded : internalIsExpanded;
    const onToggleExpansion = controlledOnToggleExpansion !== undefined
        ? controlledOnToggleExpansion
        : () => setInternalIsExpanded(!internalIsExpanded);

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            title={title}
            icon={Users}
        >
            <div className="space-y-4 mt-6">
                <div className="space-y-1.5 p-4 rounded-lg bg-primary/[0.02] border border-primary/10 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Specific Audience</div>
                    <p className="text-sm text-foreground/80 font-light leading-relaxed">{audience.specificAudience}</p>
                </div>
                <div className="space-y-1.5 p-4 rounded-lg bg-primary/[0.02] border border-primary/10 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Situation</div>
                    <p className="text-sm text-foreground/80 font-light leading-relaxed">{audience.situation}</p>
                </div>
                <div className="space-y-1.5 p-4 rounded-lg bg-primary/[0.02] border border-primary/10 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">How This Differs from Book Audience</div>
                    <p className="text-sm text-foreground/80 font-light leading-relaxed">{audience.differencesFromBook}</p>
                </div>
            </div>
            {audience.sources?.length > 0 && (
                <div className="pt-4 border-t border-border/10">
                    <SourceLinks sources={audience.sources} />
                </div>
            )}
        </DiscoveryCard>
    );
}
